import $ from 'jquery';
import _ from 'underscore';
import videojs from 'video.js';

import userAgent from 'js/constants/userAgent';

import playbackRateMenuSectionTemplate from 'bundles/videojs/layout/playbackRateMenuSection.html';

class PlaybackRateMenuSection extends videojs.getComponent('MenuItem') {
  constructor(player, options) {
    super(player, options);

    $(this.el_).find('[data-js="c-playback-rate-minus-button"]').click(this.decreasePlaybackRate.bind(this));
    $(this.el_).find('[data-js="c-playback-rate-plus-button"]').click(this.increasePlaybackRate.bind(this));

    this.updateVisibility();

    this.player_.on('ratechange', this.changeRateText.bind(this));
    this.player_.on('loadstart', this.updateVisibility.bind(this));

    this.changeRateText.call(this);
  }

  name() {
    return 'PlaybackRateMenuSection';
  }

  createEl(type, props) {
    return $(playbackRateMenuSectionTemplate())[0];
  }

  updateVisibility() {
    if (this.isPlaybackRateSupported()) {
      this.removeClass('vjs-hidden');
    } else {
      this.addClass('vjs-hidden');
    }
  }

  isPlaybackRateSupported() {
    // android passes the test for playback, but still doesn't support it (yet...)
    return (
      this.player_.options().playbackRates &&
      this.player().tech_ &&
      this.player().tech_.featuresPlaybackRate &&
      !userAgent.isAndroid
    );
  }

  changeRateText() {
    const rateText = this.player_.playbackRate().toFixed(2) + 'x';
    $(this.el_).find('[data-js="c-playback-rate-text"]').text(rateText);
  }

  getRateIndex() {
    return _.indexOf(this.playbackRates_, this.player_.playbackRate() || 1.0);
  }

  decreasePlaybackRate() {
    if (!(this.player_.playbackRate() === _.first(this.playbackRates_)) && this.player_.options().playbackRates) {
      this.player_.playbackRate(this.playbackRates_[this.getRateIndex() - 1]);
    }
  }

  increasePlaybackRate() {
    if (!(this.player_.playbackRate() === _.last(this.playbackRates_)) && this.player_.options().playbackRates) {
      this.player_.playbackRate(this.playbackRates_[this.getRateIndex() + 1]);
    }
  }

  options_ = {
    name: 'playbackRateMenuSection',
  };

  playbackRates_ = [0.75, 1, 1.25, 1.5, 1.75, 2];
}

videojs.registerComponent('PlaybackRateMenuSection', PlaybackRateMenuSection);
